wbApp.controller('AttendanceLogMpsvStudentReportParamsCtrl', ['$scope', 'rfidCardsSvc', '$translate', 'localStorageService', 'groupSvc',
    function ($scope, rfidCardsSvc, $translate, localStorageService, groupSvc) {

    $scope.modelOrig = angular.copy($scope.model);

    $scope.repParams = {};

    function loadDefaultData() {
        if (localStorageService.isSupported) {
            $scope.repParams.projectName = localStorageService.get('mpsv_projectName');
            $scope.repParams.projectRegistrationNumber = localStorageService.get('mpsv_projectRegistrationNumber');
            $scope.repParams.recipientName = localStorageService.get('mpsv_recipientName');
        }
    }

    function saveDefaultData() {
        if (localStorageService.isSupported) {
            localStorageService.set('mpsv_projectName', $scope.repParams.projectName);
            localStorageService.set('mpsv_projectRegistrationNumber', $scope.repParams.projectRegistrationNumber);
            localStorageService.set('mpsv_recipientName', $scope.repParams.recipientName);
        }
    }

    loadDefaultData();

    $scope.studentIsSelected = false;    

    $scope.detailIsUnchanged = function (data) {
        return !$scope.studentIsSelected || !!$scope.isLoadingData;
    };

    function loadData(fromDate, toDate) {

        if (!fromDate || !toDate) {
            return;
        }

        $scope.isLoadingData = true;
        $scope.studentIsSelected = false;
        $scope.students = rfidCardsSvc.getRegisteredStudentsForPeriodAsync(fromDate, toDate);

        $scope.students.$promise.then(function () {
            $scope.isLoadingData = false;
        });
    }

    function updateDetailError(shouldMessageBePresent, msg) {
        if (shouldMessageBePresent) {
            // remove msg
            if (!!$scope.detailError &&
                !!$scope.detailError.errors &&
                $scope.detailError.errors.length > 0) {
                var idx = _.findIndex($scope.detailError.errors, { message: msg });
                if (idx !== -1) {
                    $scope.detailError.errors.splice(idx, 1);
                }
                if ($scope.detailError.errors.length === 0) {
                    $scope.detailError = null;
                }
            }
        } else {
            // add msg
            if (!$scope.detailError) {
                $scope.detailError = { errors: [{ message: msg }] };
            } else {
                if (!$scope.detailError.errors) {
                    $scope.detailError.errors = [{ message: msg }];
                } else {
                    if (!_.find($scope.detailError.errors, { message: msg })) {
                        $scope.detailError.errors.push({ message: msg });
                    }
                }
            }
        }
    }

    $scope.detailError = {
        errors: [
            { message: $translate.instant('TXT_MSG_SELECT_STUDENTS_TO_INCLUDE_IN_REPORT') }
        ]
    }

    $scope.studentsGridSelectionChanged = function () {

        $scope.studentIsSelected = !!_.find($scope.students, { isSelected: true });
        var msg = $translate.instant('TXT_MSG_SELECT_STUDENTS_TO_INCLUDE_IN_REPORT');

        updateDetailError($scope.studentIsSelected, msg);
    };

    loadData($scope.fromDate, $scope.toDate);

    $scope.detailTabs = [{
        title: "TXT_MAIN",
        template: "rfid-cards/attendance-log/attendance-log-mpsv-student-attendance-report-main-tab.html"
    },{
        title: 'TXT_LBL_STUDENTS',
        template: "rfid-cards/attendance-log/attendance-log-mpsv-student-attendance-report-students-tab.html"
    }];

    $scope.rangeChanged = function (fromDate, toDate) {
        loadData(fromDate, toDate);
    }

    $scope.groups = groupSvc.getAllAsync();

    $scope.studentsGridFilterOptions = {
        groups: [],
        filterText: "",
        filterFunction: function (value, index) {
            if (!$scope.studentsGridFilterOptions.groups.length) {
                return true;
            }

            return _.intersection(value.groups, $scope.studentsGridFilterOptions.groups).length > 0;
        }
    };

    $scope.$watch('studentsGridFilterOptions.groups', function (newValue, oldValue) {
        if (!!newValue && newValue.length === 1) {
            $scope.groups.$promise.then(function (g) {
                var group = _.find(g, { 'groupID': newValue[0] });
                if (group) {
                    if (group.projectName) {
                        $scope.repParams.projectName = group.projectName;
                    }
                    if (group.projectRegistrationNumber) {
                        $scope.repParams.projectRegistrationNumber = group.projectRegistrationNumber;
                    }
                    if (group.projectBeneficiary) {
                        $scope.repParams.recipientName = group.projectBeneficiary;
                    }
                }
            });
        }
    });

    $scope.studentsGridOptions = {
        sortInfo: { fields: ['fullName'], directions: ['asc'] },
        columnDefs: [
            { field: 'deviceSerialNumber', displayName: "TXT_LBL_DEVICE_SERIAL_NUMBER", width: '90px' },
            { field: 'fullName', displayName: "TXT_HUMAN_NAME", sort: 'humanName' },
            { field: 'parentFullName', displayName: "TXT_LBL_PARENT"},
            { field: 'email', displayName: "TXT_LBL_EMAIL", width: '180px' },
            { field: 'phone', displayName: "TXT_LBL_PHONE", cellFilter: "phone", width: '130px' },
            { field: 'groups', displayName: "TXT_LBL_GROUPS", hidden: true },
        ],
        noCommandColumn: true,
        multiSelect: true,
        disableExport: true
    };

    $scope.isSaving = false;

    $scope.onDetailSave = function (model) {

        $scope.isSaving = true;

        var students = _.map(_.filter($scope.students, { isSelected: true }), 
            function (s) { return { studentID: s.studentID, deviceSerialNumber: s.deviceSerialNumber }; });

        saveDefaultData();

        $scope.$hide();

        $scope.reportGenerated(
            $scope.fromDate,
            $scope.toDate,
            students,
            $scope.repParams.projectName,
            $scope.repParams.projectRegistrationNumber,
            $scope.repParams.recipientName);
    }
}]);
